<template>
  <b-card no-body>
    <b-row>
    <b-col cols="6">
    <b-card-img :src="post.media_url" alt="Image"  style="height: 500px;"></b-card-img>
    </b-col>
    <b-col cols="6">
      
    <b-card-body class="px-0">
      <b-row class="mb-1">
        <b-col cols="6" class="d-flex">
          <feather-icon icon="HeartIcon" class="mr-50" size="20" />
          <b-card-text
            >{{ post.like_count }}
            {{
              post.like_count === 1 || post.like_count === 0 ? "Like" : "Likes"
            }}</b-card-text
          >
        </b-col>
        <b-col cols="6" class="d-flex">
          <feather-icon icon="MessageCircleIcon" class="mr-50" size="20" />
          <b-card-text
            >{{ post.comments_count }}
            {{
              post.comments_count === 1 || post.comments_count === 0
                ? "Comment"
                : "Comments"
            }}</b-card-text
          >
        </b-col>
      </b-row>

      <b-card-text class="caption" v-if="post.caption!=null"
        ><b>{{ post.username }}:</b> {{ post.caption }}</b-card-text
      >
      <b-card-text class="caption" v-else
        >No Caption</b-card-text
      >
      <hr />
      <b-card-text class="comments" v-if="post.comments_count > 0">
        <b>{{ post.comments.data[0].username }}</b>
        {{ post.comments.data[0].text }}
      </b-card-text>
      <b-card-text class="comments" v-else>No comments yet</b-card-text>
    </b-card-body>
    <b-card-footer class="px-0 border-0">
      <b-row class="justify-content-between">
        <b-col cols="6">
          <b-button
            variant="primary"
            class="w-100"
            :href="post.permalink"
            target="_blank"
            >View Post</b-button
          >
        </b-col>
        <b-col cols="6">
          <b-button variant="danger" class="w-100">Delete</b-button>
        </b-col>
      </b-row>
    </b-card-footer>
    </b-col>

    </b-row>
  </b-card>
</template>

<style scoped>
.caption {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* Limit number of lines to 2 */
  -webkit-box-orient: vertical;
  min-height: 3rem; /* Adjust as needed based on your design */
}
.comments {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1; /* Limit number of lines to 1 */
  -webkit-box-orient: vertical;
  min-height: 0.5rem;
}
</style>

<script>
import {
  BCard,
  BCardImg,
  BCardText,
  BButton,
  BRow,
  BCol,
  BCardBody,
  BCardFooter
} from "bootstrap-vue";

export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  components: {
    BCard,
    BCardImg,
    BCardText,
    BButton,
    BRow,
    BCol,
    BCardBody,
    BCardFooter
  },
  methods: {
    viewPost() {
      // Handle view post action
      console.log("View post:", this.post);
    },
    deletePost() {
      // Handle delete post action
      console.log("Delete post:", this.post);
    },
  },
};
</script>
